<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal, ModalBody, ModalFooter } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { CampaignForm } from '../shared';

  export let show = false;
  export let showNextModal = false;
  export let campaignData = {};
  export let tagFilters = [];

  let rulename = '';
  let enableSchedule = false;
  let selectedTags = [];
  let selectedCategories = [];
  let startDate = '';
  let endDate = '';
  let selectedFolders = [];
  let invalidRulename = false;

  const onCloseModal = () => {
    campaignData = {};
    rulename = '';
    enableSchedule = false;
    selectedTags = [];
    selectedCategories = [];
    selectedFolders = [];
    startDate = '';
    endDate = '';

    show = false;
  };

  const onKeyUp = (event) => {
    if (event.key === 'Escape') {
      onCloseModal();
    }
  };

  const onShowNextModal = () => {
    let categories = {};

    selectedCategories.forEach((category) => {
      categories[category.value] = category.checked;
    });

    if (enableSchedule) {
      endDate = new Date(endDate).toISOString();
      startDate = new Date(startDate).toISOString();
    }

    campaignData = {
      rulename,
      enableschedule: enableSchedule,
      schedule: enableSchedule
        ? {
            startDate,
            endDate
          }
        : null,
      tags: selectedTags.map((tag) => ({ text: tag.value })),
      category: categories,
      folderid: selectedFolders.length ? selectedFolders[0] : null
    };

    show = false;
    setTimeout(() => (showNextModal = true), 200);
  };

  $: isDisabled = invalidRulename || !rulename.length;
</script>

<Modal bind:isOpen={show} size="lg" fullscreen="lg">
  <ModalBody class="campaign-modal modal--content">
    <div class="modal-actions">
      <button class="close" on:click={onCloseModal}>
        <Icon name="x" />
      </button>
    </div>

    <div>
      <h1>{$format('label.NEW_CAMPAIGN')}</h1>
      <p>{$format('label.DESCRIPTION.NEW_CAMPAIGN')}</p>
    </div>

    <div class="modal-body">
      <CampaignForm
        {tagFilters}
        bind:rulename
        bind:enableSchedule
        bind:selectedTags
        bind:selectedCategories
        bind:startDate
        bind:endDate
        bind:selectedFolders
        bind:invalidRulename
      />
    </div>
  </ModalBody>
  <ModalFooter>
    <Button id="modal-next-btn" color="primary" on:click={onShowNextModal} disabled={isDisabled}>
      {$format('label.NEXT')} <Icon name="arrow-right" />
      {$format('label.SETUP')}
    </Button>
  </ModalFooter>
</Modal>

<svelte:window on:keyup={onKeyUp} />

<style lang="scss" src="./campaign.scss"></style>
